module.exports = __webpack_public_path__ + "assets/img/jianxia_score-e1b82b73.png";